/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seller_Calendar_Block_DateInputs */

const en_seller_calendar_block_date = /** @type {(inputs: Seller_Calendar_Block_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Block Date Range`)
};

const es_seller_calendar_block_date = /** @type {(inputs: Seller_Calendar_Block_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bloquear Rango de Fechas`)
};

const fr_seller_calendar_block_date = /** @type {(inputs: Seller_Calendar_Block_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bloquer la plage de dates`)
};

const de_seller_calendar_block_date = /** @type {(inputs: Seller_Calendar_Block_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datumsbereich blockieren`)
};

const id_seller_calendar_block_date = /** @type {(inputs: Seller_Calendar_Block_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blokir Rentang Tanggal`)
};

/** @type {(inputs: Seller_Calendar_Block_DateInputs) => LocalizedString} */
const ja_seller_calendar_block_date = en_seller_calendar_block_date;

/** @type {(inputs: Seller_Calendar_Block_DateInputs) => LocalizedString} */
const zh_seller_calendar_block_date = en_seller_calendar_block_date;

/** @type {(inputs: Seller_Calendar_Block_DateInputs) => LocalizedString} */
const ar_seller_calendar_block_date = en_seller_calendar_block_date;

/** @type {(inputs: Seller_Calendar_Block_DateInputs) => LocalizedString} */
const it_seller_calendar_block_date = en_seller_calendar_block_date;

/** @type {(inputs: Seller_Calendar_Block_DateInputs) => LocalizedString} */
const ru_seller_calendar_block_date = en_seller_calendar_block_date;

/** @type {(inputs: Seller_Calendar_Block_DateInputs) => LocalizedString} */
const pt_seller_calendar_block_date = en_seller_calendar_block_date;

/** @type {(inputs: Seller_Calendar_Block_DateInputs) => LocalizedString} */
const ko_seller_calendar_block_date = en_seller_calendar_block_date;

/**
* | output |
* | --- |
* | "Block Date Range" |
*
* @param {Seller_Calendar_Block_DateInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const seller_calendar_block_date = /** @type {((inputs?: Seller_Calendar_Block_DateInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seller_Calendar_Block_DateInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_seller_calendar_block_date(inputs)
	if (locale === "es") return es_seller_calendar_block_date(inputs)
	if (locale === "fr") return fr_seller_calendar_block_date(inputs)
	if (locale === "de") return de_seller_calendar_block_date(inputs)
	if (locale === "ja") return ja_seller_calendar_block_date(inputs)
	if (locale === "zh") return zh_seller_calendar_block_date(inputs)
	if (locale === "ar") return ar_seller_calendar_block_date(inputs)
	if (locale === "id") return id_seller_calendar_block_date(inputs)
	if (locale === "it") return it_seller_calendar_block_date(inputs)
	if (locale === "ru") return ru_seller_calendar_block_date(inputs)
	if (locale === "pt") return pt_seller_calendar_block_date(inputs)
	return ko_seller_calendar_block_date(inputs)
});